import React from 'react'
import humanizeTime from '../../helpers/humanizeTime'
import ObjectInspector from "react-inspector"

const HistoryItem = (props) => {
    const {
        key,
        className,
        item
    } = props
    return (
        <div key={key} className={className}>
            <div className="card border">
                <div className="d-flex align-items-center justify-content-start card-header py-1" style={{ background: '#e9ecef' }}>
                    <span className='card-header-time'>
                        {humanizeTime(item.created_at)}
                    </span>
                </div>

                <div className="card-body" style={{ paddingTop: 20 }}>
                    <div className="row align-items-baseline mb-1">
                        <div className="col-4">
                            <div style={{ fontSize: 15, color: '#e83e8c', wordBreak: 'break-word' }}>{item.event}</div>
                        </div>

                        <div className="col-4 text-muted">{item.description}</div>
                        <div className="col-4">
                            <div className="User">
                                <div>{item.user}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-baseline">
                        <div className="col-4">Value</div>
                        <div className="col-4">
                            <ObjectInspector depth={0} path="root.value" data={item.meta} />
                        </div>
                        <div className="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoryItem